import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
// import reportWebVitals from './reportWebVitals';
// import { useEffect } from 'react';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);



// mt menuToggle reset
let mtreset = window.matchMedia("(max-width: 560px)");

mtreset.onchange = (e) => {
  let navBar = document.querySelector('.navBar');
  let menuIcon = document.getElementById('menuIcon');
  if (e.matches) {
    // console.log('menu is showing');
    navBar.style.display = "none";
  } else {
    // console.log('menu is hidden');
    navBar.style.display = "flex";
    menuIcon.classList.remove('fa-minus');
    menuIcon.classList.add('fa-caret-down');
  }
};



